import Vue from 'vue';

export default {
  // 竞价大厅列表
  getBidselectList(params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/selectBidList', params);
  },
  // 去竞价
  getEjyToken (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/user/getBiddingToken/' + bidId);
  }
};
